export default (() => {
  class SearchForm {
    constructor($searchForm, titleSelector, resultsSelector, filterContainerSelector, filterSelector) {
      this.$form = $searchForm
      this.$input = this.$form.find('[data-search-input]')
      this.$submitButton = this.$form.find('[data-search-button]')
      this.$title = $(titleSelector)
      this.$resultsContainer = $(resultsSelector)
      this.$filterButtonsContainer = $(filterContainerSelector)
      this.$filterButtons = $(filterSelector)
      this.$showMore = this.$resultsContainer.find('[data-search-show-more]')
      this.currentPage = 0
      this.hitsPerPage = 15
    }

    getResults() {
      var self = this
      var q = self.$input.val()
      var types = []
      var typesAloglia = []

      self.$input.attr('disabled', true)
      self.$submitButton.attr('disabled', true)

      self.$filterButtons.each(function () {
        $(this).attr('disabled', true)
        if ($(this).is('[data-active]')) {
          var groupedTypes = $(this).attr('data-search-filter').split(',')
          for (var i = 0; i < groupedTypes.length; i++) {
            typesAloglia.push('type:"' + groupedTypes[i] + '"')
            types.push(groupedTypes[i])
          }
        }
      })

      var searchParams = {
        attributesToRetrieve: [
          'title',
          'url',
          'document__url',
          'type',
          'status',
          'general__abstract',
          'studyArea__abstract',
          'discipline__abstract',
          'course__abstract',
          'course__courseCode',
          'course__accrdCourse',
        ],
        attributesToHighlight: [
          'title',
          'general__abstract',
          'studyArea__abstract',
          'discipline__abstract',
          'course__abstract',
          'course__courseCode',
        ],
        hitsPerPage: self.hitsPerPage,
        page: self.currentPage,
      }

      var filterString = '(status:"live") AND (start_ts >= ' + Math.floor(Date.now() / 1000) + ')'
      var paramsString = '?q=' + encodeURIComponent(q)

      if (typesAloglia.length) {
        filterString += ' AND (' + typesAloglia.join(' OR ') + ')'
        paramsString += '&types=' + types.join(',')
      }

      searchParams.filters = filterString

      self.$resultsContainer.addClass('opened')

      // Update URL params
      window.history.pushState({ search: 'apply_types' }, document.title, window.location.href.split('?')[0] + paramsString)

      if (q != '') {
        $.ajax({
          url: '/actions/algolia/default/search',
          cache: false,
          dataType: 'json',
          method: 'post',
          data: JSON.stringify({
            index: self.$input.attr('data-search-input'),
            query: q,
            params: searchParams,
          }),
          success: function (response) {
            self.clearLoading()
            if (self.$showMore.length) {
              self.$showMore.closest('[data-search-show-more-container]').remove()
            }
            self.showResults(response)
          },
          error: function (response) {
            self.clearLoading()
            self.clearResults()
          },
        })
      } else {
        self.clearLoading()
        self.clearResults()
      }
    }

    clearResults() {
      var self = this
      self.currentPage = 0
      self.$title.empty()
      self.$resultsContainer.empty()
      self.$resultsContainer.removeClass('opened')
    }

    showLoading() {
      var self = this
      var $loadingOverlay = $(
        '<div class="overlay d-flex justify-content-center align-items-center">\
          <div class="spinner-border text-primary m-3 spinner-grow-lg" role="status"></div>\
          <div>Loading results, please wait...</div>\
      </div>'
      )
      self.$resultsContainer.append($loadingOverlay)
    }

    clearLoading() {
      var self = this
      self.$input.removeAttr('disabled')
      self.$submitButton.removeAttr('disabled')
      self.$filterButtons.removeAttr('disabled')
      self.$resultsContainer.find('.overlay').remove()
    }

    showResults(response) {
      var self = this
      var results = []
      var typesToTag = ['Study Area', 'Short Course Study Area', 'Discipline', 'Course', 'News Article', 'Event', 'Campus', 'Document']

      if (response.nbHits > 0) {
        self.$filterButtonsContainer.removeClass('d-none')
        self.$title.html(
          '<h1 class="h4">Search term "' + self.$input.val() + '" found ' + response.nbHits + ' result' + (response.nbHits > 1 ? 's' : '') + ':</h4>'
        )

        for (var i = 0; i < response.hits.length; i++) {
          results.push(
            '<a href="' +
              (response.hits[i].type == 'Document' ? response.hits[i].document__url : response.hits[i].url) +
              '">\
            <div class="search-result">\
              <div class="search-result-title">' +
              response.hits[i]._highlightResult.title.value +
              (response.hits[i]._highlightResult.hasOwnProperty('course__courseCode')
                ? ' (' + response.hits[i]._highlightResult.course__courseCode.value + ')'
                : '') +
              '</div>\
              ' +
              (response.hits[i].hasOwnProperty('course__accrdCourse')
                ? '<div class="accrd-course"><span>from ' + response.hits[i].course__accrdCourse + '</span></div>'
                : '') +
              '\
              ' +
              (typesToTag.includes(response.hits[i].type) ? '<div class="search-result-type">' + response.hits[i].type + '</div>' : '') +
              '\
              <div class="search-result-text">\
                  ' +
              (response.hits[i]._highlightResult.hasOwnProperty('general__abstract')
                ? '<div class="search-result-text-inner">' + self.truncateText(response.hits[i]._highlightResult.general__abstract.value) + '</div>'
                : '') +
              '\
                  ' +
              (response.hits[i]._highlightResult.hasOwnProperty('studyArea__abstract')
                ? '<div class="search-result-text-inner">' + self.truncateText(response.hits[i]._highlightResult.studyArea__abstract.value) + '</div>'
                : '') +
              '\
                  ' +
              (response.hits[i]._highlightResult.hasOwnProperty('discipline__abstract')
                ? '<div class="search-result-text-inner">' +
                  self.truncateText(response.hits[i]._highlightResult.discipline__abstract.value) +
                  '</div>'
                : '') +
              '\
                  ' +
              (response.hits[i]._highlightResult.hasOwnProperty('course__abstract')
                ? '<div class="search-result-text-inner">' + self.truncateText(response.hits[i]._highlightResult.course__abstract.value) + '</div>'
                : '') +
              '\
              </div>\
            </div>\
          </a>'
          )
        }
        self.$resultsContainer.append(
          '<div class="row"><div class="col-12 col-lg-8" data-results-container-page>' + results.join('') + '</div></div>'
        )

        self.showMoreButton(response)
      } else {
        self.$resultsContainer.removeClass('opened')
        //self.$filterButtonsContainer.addClass('d-none');
        self.clearResults()
        self.$title.html('<h1 class="h4">Search term "' + self.$input.val() + '" returned no results.</h4>')
      }
    }

    showMoreButton(response) {
      var self = this

      if (response.nbPages <= response.page + 1) {
        return
      }

      var $showMoreContainer = $('<div class="d-flex justify-content-center" data-search-show-more-container>')
      self.$showMore = $('<button class="btn btn-primary" data-search-show-more>Show more</button>')

      self.$showMore.on('click', function () {
        self.showMoreClick()
      })

      $showMoreContainer.html(self.$showMore)
      self.$resultsContainer.find('[data-results-container-page]').last().append($showMoreContainer)
    }

    showMoreClick() {
      var self = this

      self.$showMore.attr('disabled', true).text(' Please wait …')
      self.$showMore.prepend('<span class="spinner-btn mr-2" role="status" aria-hidden="true"></span>')
      self.currentPage++
      self.getResults()
    }

    truncateText(text) {
      var self = this

      if (text.length > 300) {
        text = text.substring(0, 300)
        if (text.slice(-1) == '.') {
          text += '..'
        } else if (text.slice(-1) == ' ') {
          text += '...'
        } else {
          text += ' ...'
        }
      }
      return text
    }

    submitForm(e) {
      var self = this

      e.preventDefault()
      self.clearResults()
      self.showLoading()
      self.getResults()
      return false
    }

    init() {
      var self = this

      self.$form.on('submit', function (e) {
        self.submitForm(e)
      })

      self.$filterButtons.on('click', function () {
        if ($(this).attr('data-search-filter') == 'all') {
          self.$filterButtons.removeClass('on').removeAttr('data-active')
          $(this).addClass('on')
        } else {
          if ($(this).is('[data-active]')) {
            $(this).removeClass('on').removeAttr('data-active')
          } else {
            $(this).addClass('on').attr('data-active', '1')
            $(this).parent().find('[data-search-filter="all"]').removeClass('on')
          }
          if ($('[data-search-filter][data-active]').length < 1) {
            $(this).parent().find('[data-search-filter="all"]').addClass('on')
          }
        }
        self.clearResults()
        self.showLoading()
        self.getResults()
      })

      self.$showMore.on('click', function () {
        self.showMoreClick()
      })

      // Back button click
      $(window).on('popstate', function (e) {
        window.location.reload()
      })

      // Search input clear
      $('.js-search-reset').on('click', function (e) {
        self.$input.val('')
        self.$filterButtons.removeClass('on').removeAttr('data-active')
        self.$filterButtons.find('[data-search-filter="all"]').addClass('on')
        self.submitForm(e)
      })
    }
  }

  $('[data-search-form]').each(function () {
    const searchForm = new SearchForm(
      $(this),
      '[data-search-title]',
      '[data-search-results-container]',
      '[data-search-filter-container]',
      '[data-search-filter]'
    )
    searchForm.init()
  })
})()
